import { render, staticRenderFns } from "./checklistWorkTabItem.vue?vue&type=template&id=5af0bf31&scoped=true&"
import script from "./checklistWorkTabItem.vue?vue&type=script&lang=js&"
export * from "./checklistWorkTabItem.vue?vue&type=script&lang=js&"
import style0 from "./checklistWorkTabItem.vue?vue&type=style&index=0&id=5af0bf31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0bf31",
  null
  
)

export default component.exports